// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1_FdX","cls2":"AccountMenuButton-cls2__cA AccountMenuButton-cls1_FdX"};